import { useMutation, useQueryClient } from '@tanstack/react-query';
import detachCredits from '../../api/credits/detach-credits';
import refetchCart from '../cart/refetch-cart';

const useDetachCredits = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: detachCredits,
        onSuccess: () => refetchCart(queryClient)
    });
};

export default useDetachCredits;
